// Globaler "Wo bin ich gerade"-Kontext für den Agent-Chat.
//
// Seiten (z.B. Emails) melden hier, welches Objekt der Nutzer gerade offen hat.
// Das AgentWidget liest das und bietet einen wegklickbaren "Bezug"-Chip an, damit
// man "antworte darauf" sagen kann, ohne die E-Mail erneut zu beschreiben.
//
// Bewusst ein winziger Pub-Sub-Store ohne Abhängigkeiten — kein globaler State-
// Manager nötig. Kontext ist immer ein Hinweis, nie ein Zwang: der Nutzer sieht
// den Chip und kann ihn entfernen.
//
// Form: { type: 'email', id, label, ...zusatzfelder } oder null

let current = null
const listeners = new Set()

export function setAgentContext(ctx) {
  // Gleichen Kontext nicht doppelt feuern (verhindert unnötige Re-Render)
  if (current?.type === ctx?.type && current?.id === ctx?.id) {
    if (!ctx && !current) return
    if (ctx && current && ctx.id === current.id) return
  }
  current = ctx || null
  for (const fn of listeners) {
    try { fn(current) } catch { /* listener-Fehler ignorieren */ }
  }
}

export function getAgentContext() {
  return current
}

export function subscribeAgentContext(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
